import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, race, filter as rxjsFilter, take, takeUntil } from 'rxjs';
import { SocketService } from '@app/core/services/socket.service';
import { HubData } from '../sockets/shared/interfaces';

@Injectable({
	providedIn: 'root',
})
export class SocketMonitorService {
	constructor(private readonly socketService: SocketService) {}

	monitorSocketProcess(processId: string, destroy$: Observable<any> | DestroyRef): Observable<HubData> {
		if (destroy$ instanceof DestroyRef) {
			return race(
				this.socketService.error$.pipe(
					takeUntilDestroyed(destroy$),
					rxjsFilter((notification: HubData) => notification.Id === processId),
					take(1),
				),
				this.socketService.success$.pipe(
					takeUntilDestroyed(destroy$),
					rxjsFilter((notification: HubData) => notification.Id === processId),
					take(1),
				),
			);
		}

		return race(
			this.socketService.error$.pipe(
				takeUntil(destroy$),
				rxjsFilter((notification: HubData) => notification.Id === processId),
				take(1),
			),
			this.socketService.success$.pipe(
				takeUntil(destroy$),
				rxjsFilter((notification: HubData) => notification.Id === processId),
				take(1),
			),
		);
	}
}
